import { GET_BUSINESS_ROLE_AND_STAFF, GET_REMARK_ROLE_AND_STAFF, SET_WORK_FLOW_ROLES, SET_WORK_FLOW_STAFF_ROLES, SET_WORK_FLOW_TYPE } from "../../types/workflow"

// ** Initial State
const initialState = {
  itemsRedux: [],
  isLoading: false,
  isPageLoading: false,
  workflowList: [],
  workflowDetail: {},
  initialWorkflowDetail: {},
  workflowActiveUser: [],
  workflowRoles: [],
  workflowStaffRoles: [],
  workflowTemplateFileSystem: {},
  worflflowUpdatedData: {},
  workflowFilterdata: [],
  workflowByExtension: {},
  workflowByExtensions: {},
  type: "",
  staffRoles: [],
  businessRoleAndStaffs: [],
  remarkRoleAndStaffs: null,
  requiredUpdateTasks: [],
  errorData: {},
  editWorkflowSuccessShow: false,
  reportTagWise: []
}

const workFlowReducer = (state = initialState, action) => {
  switch (action.type) {
    case "ERROR_PROMPT":
      return { ...state, errorData: action.payload }
    case "WORK_FLOW_LOADING":
      return { ...state, isLoading: action.payload }
    case "PAGE_LOADING":
      return { ...state, isPageLoading: action.payload }
    case "GET_WORK_FLOW_Data":
      return { ...state, workflowList: action.payload }
    case "GET_WORK_FLOW_DATA_BY_ID":
      return { ...state, workflowDetail: action.payload }
    case "SET_INITIAL_WORKFLOW_DATA":
      const newPayload = JSON.parse(JSON.stringify({ ...action.payload }))
      return { ...state, initialWorkflowDetail: newPayload }
    case "INITIAL_WORKFLOW_DATA_START_DATE":
      return { ...state, workflowDetail: { ...state.workflowDetail, startDate: action.payload } }
    case "ADD_WORK_FLOW_DATA":
      return {
        ...state,
        workflowList: [...state.workflowList, action.payload]
      }
    case "EDIT_WORK_FLOW_DATA":
      return {
        ...state,
        workflowDetail: action.payload
      }
    // case "EDIT_WORKFLOW":
    //   return {
    //     ...state,
    //     worflflowUpdatedData: action.payload
    //   }
    case "EDIT_WORKFLOW_SUCCESS_SHOW":
      return {
        ...state,
        editWorkflowSuccessShow: action.payload
      }
    case "DELETE_WORK_FLOW_DATA":
      return {
        ...state,
        workflowList: state.workflowList.filter((x) => { return !action.payload.includes(x._id) ? x : false })
      }
    case "GET_WORK_FLOW_STATUS":
      return {
        ...state,
        workflowStatus: action.payload
      }
    case "GET_WORK_FLOW_ACTIVE_USERS":
      return {
        ...state,
        workflowActiveUser: action.payload
      }
    case GET_BUSINESS_ROLE_AND_STAFF:
      return {
        ...state,
        businessRoleAndStaffs: action.payload
      }
    case GET_REMARK_ROLE_AND_STAFF:
      return {
        ...state,
        remarkRoleAndStaffs: action.payload
      }
    case "STAFF_ROLE": {
      return {
        ...state,
        staffRoles: action.payload
      }
    }
    case SET_WORK_FLOW_ROLES:
      return {
        ...state,
        workflowRoles: action.payload
      }
    case SET_WORK_FLOW_STAFF_ROLES:
      return {
        ...state,
        workflowStaffRoles: action.payload
      }
    case SET_WORK_FLOW_TYPE: {
      return {
        ...state,
        type: action.payload
      }
    }
    case "GET_UPLOADFILES_FILESYSTEM":
      return {
        ...state,
        workflowTemplateFileSystem: action.payload
      }
    case "GET_UPLOAD_FILE_DATA":
      return {
        ...state,
        workFlowUploadedFile: action.payload
      }
    case "LIST_EMAIL_ATTACHMENT_FILE":
      return {
        ...state,
        workFlowEmailAttachment: action.payload
      }
    case "GET_WORKFLOW_FILTER_DATA":
      return {
        ...state,
        workflowFilterdata: action.payload?.data?.data
      }
    case "GET_WORKFLOW_BY_EXTENSION":
      return {
        ...state,
        workflowByExtension: action.payload
      }
    case "GET_WORK_FLOW_DATA_BY_EXTENSIONS":
      return {
        ...state,
        workflowByExtensions: action.payload
      }
    case "REQUIRED_UPDATE_TASK":
      return {
        ...state,
        requiredUpdateTasks: action.payload
      }
    case "BRANCH_COMPANY_DIALOG_SHOW":
      return {
        ...state,
        handleBranchCompany: action.payload
      }
    case "UPDATE_WORKFLOW_TITLE":
      return {
        ...state,
        workflowDetail: { ...state.workflowDetail, workflowTitle: action.payload }
      }
    case "SET_TAGWISE_REPORT_DATA":
      return {
        ...state,
        reportTagWise: action.payload
      }   
    default:
      return state
  }
}

export default workFlowReducer
